module.exports = __webpack_public_path__ + "img/welcome_4.3178f1ef.jpg";